import { render, staticRenderFns } from "./TgMallDownloadPage.vue?vue&type=template&id=6c02d89a&"
import script from "./TgMallDownloadPage.vue?vue&type=script&lang=js&"
export * from "./TgMallDownloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports